/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Link, useNavigate } from 'react-router-dom';

import {
  Grid2,
  Button as ButtonMaterial,
  Typography,
  Dialog,
  CircularProgress,
  DialogTitle,
  Box,
  IconButton,
  DialogContent,
  DialogActions,
  SpeedDial,
  SpeedDialAction,
} from '@mui/material';

import { MeterCard } from '../../components';

import { showMeters, getMeterFailure } from 'js/actions/meterActions';

import {
  getSnapShot,
  postSnapShot,
  updateSnapShop,
} from 'js/actions/userActions.js';
import AddIcon from '@mui/icons-material/Add';
import FromStrepper from './FromStrepper';
import { useIntl } from 'react-intl';
import { Close, Settings } from '@mui/icons-material';
import UploadDocuments from '../UploadDocuments';

export default function GridMeter(props) {
  const intl = useIntl();
  const { coporative_id } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const meters = useSelector((state) => state.meters.meters);
  const [showDetails, setShowDetails] = useState(false);
  const [selectedCorp, setSelectedCorp] = useState(null);
  const [openDocuments, setOpenDocuments] = useState(false);
  let meterStatus = useSelector((state) => state.meters.loading);
  let isLoading = meterStatus;
  const [snapShopView, setSnapShopView] = useState(false);
  const [formData, setFormData] = useState({
    resource_id: '',
    type: 'NODO',
    frecuency_config: {
      periods: [],
      days: [],
    },
    contacts: [],
  });
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const { snapShot } = useSelector((state) => state.user);

  const handleNavigation = () => {
    navigate(`/newMeter/${coporative_id}`, { state: { coporative_id } });
  };

  useEffect(() => {
    if (selectedCorp) {
      dispatch(getSnapShot(selectedCorp.id, 'NODO'));
    }
  }, [selectedCorp]);

  useEffect(() => {
    if (snapShot && snapShot.length > 0) {
      setFormData(snapShot[0]);
    }
  }, [snapShot]);

  useEffect(() => {
    dispatch(getMeterFailure());
    dispatch(showMeters(coporative_id));
  }, [coporative_id]);

  const handleSnapShot = () => {
    if (snapShot && snapShot.length > 0) {
      dispatch(updateSnapShop(formData)).then(() => {
        setSnapShopView(false);
      });
    } else {
      dispatch(postSnapShot(formData)).then(() => {
        setSnapShopView(false);
      });
    }
  };

  return (
    <>
      {isLoading ? (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: '50px',
          }}
        >
          <CircularProgress />
        </div>
      ) : (
        <>
          {meters.length > 0 ? (
            <Grid2 container={true} spacing={4}>
              {meters
                .sort((a, b) =>
                  a.name !== b.name ? (a.name < b.name ? -1 : 1) : 0
                )
                .map((meter) => (
                  <Grid2 size={{ lg: 4, md: 6, xs: 12 }} key={meter.id}>
                    <MeterCard
                      corpId={coporative_id}
                      key={meter.id}
                      meter={meter}
                      setOpenDocuments={setOpenDocuments}
                      setSelectedCorp={setSelectedCorp}
                      setShowDetails={setShowDetails}
                      setSnapShopView={setSnapShopView}
                      snapShopView={snapShopView}
                    />
                  </Grid2>
                ))}
            </Grid2>
          ) : (
            <Grid2 container={true} spacing={4}>
              <Grid2 size={12}>
                <Typography sx={{ textAlign: 'center' }} variant="h2">
                  {intl.formatMessage({ id: 'app.metersCards.noMetersMsg' })}
                </Typography>
              </Grid2>
              <Grid2 size={12}>
                <Link
                  to={{
                    pathname: `/newMeter/${coporative_id}`,
                  }}
                >
                  <ButtonMaterial
                    color="secondary"
                    sx={{ margin: '0 auto', display: 'block' }}
                    variant="outlined"
                  >
                    {intl.formatMessage({
                      id: 'app.metersCards.createMeterBtn',
                    })}
                  </ButtonMaterial>
                </Link>
              </Grid2>
            </Grid2>
          )}

          <Dialog
            aria-labelledby="customized-dialog-title"
            fullWidth={true}
            maxWidth={'sm'}
            onClose={() => {
              setShowDetails(false);
            }}
            open={showDetails}
          >
            <DialogTitle
              id="customized-dialog-title"
              onClose={() => {
                setShowDetails(false);
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}
              >
                <Box>
                  <Typography variant="h6">
                    {selectedCorp ? selectedCorp.name : ''}
                  </Typography>
                </Box>
                <IconButton
                  aria-label="close"
                  onClick={() => {
                    setShowDetails(false);
                  }}
                  size="small"
                >
                  <Close />
                </IconButton>
              </Box>
            </DialogTitle>
            <DialogContent dividers={true} sx={{ marginBottom: '3rem' }}>
              {selectedCorp ? (
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '1rem',
                    alignItems: 'center',
                  }}
                >
                  <Typography
                    sx={{ fontWeight: 400, textAlign: 'center' }}
                    variant="h6"
                  >
                    <Typography sx={{ fontWeight: 500 }}>
                      {intl.formatMessage({
                        id: 'app.metersCards.editMeter.descriptLbl',
                      })}
                    </Typography>
                    {selectedCorp.description}
                  </Typography>
                  <Typography
                    sx={{ fontWeight: 400, textAlign: 'center' }}
                    variant="h6"
                  >
                    <Typography sx={{ fontWeight: 500 }}>
                      {intl.formatMessage({
                        id: 'app.metersCards.editMeter.countryLbl',
                      })}
                    </Typography>
                    {selectedCorp.country}
                  </Typography>
                  <Typography
                    sx={{ fontWeight: 400, textAlign: 'center' }}
                    variant="h6"
                  >
                    <Typography style={{ fontWeight: 500 }}>
                      {intl.formatMessage({
                        id: 'app.metersCards.editMeter.stateLbl',
                      })}
                    </Typography>
                    {selectedCorp.state}
                  </Typography>
                  <Typography
                    sx={{ fontWeight: 400, textAlign: 'center' }}
                    variant="h6"
                  >
                    <Typography style={{ fontWeight: 500 }}>
                      {intl.formatMessage({
                        id: 'app.metersCards.editMeter.cityLbl',
                      })}
                    </Typography>
                    {selectedCorp.city}
                  </Typography>
                  <Typography
                    sx={{ fontWeight: 400, textAlign: 'center' }}
                    variant="h6"
                  >
                    <Typography sx={{ fontWeight: 500 }}>
                      {intl.formatMessage({
                        id: 'app.metersCards.editMeter.postalCodeLbl',
                      })}
                    </Typography>
                    {selectedCorp.cp}
                  </Typography>
                  <Typography
                    sx={{ fontWeight: 400, textAlign: 'center' }}
                    variant="h6"
                  >
                    <Typography sx={{ fontWeight: 500 }}>
                      {intl.formatMessage({
                        id: 'app.metersCards.editMeter.neighborhoodLbl',
                      })}
                    </Typography>
                    {selectedCorp.county}
                  </Typography>
                  <Typography
                    sx={{ fontWeight: 400, textAlign: 'center' }}
                    variant="h6"
                  >
                    <Typography sx={{ fontWeight: 500 }}>
                      {intl.formatMessage({
                        id: 'app.metersCards.editMeter.addressLbl',
                      })}
                    </Typography>
                    {selectedCorp.address}
                  </Typography>
                  {selectedCorp.contracted_demand && (
                    <Typography
                      sx={{ fontWeight: 400, textAlign: 'center' }}
                      variant="h6"
                    >
                      <Typography style={{ fontWeight: 500 }}>
                        {intl.formatMessage({
                          id: 'app.metersCards.editMeter.contractedDemandLbl',
                        })}
                      </Typography>
                      {selectedCorp.contracted_demand} kW
                    </Typography>
                  )}
                </Box>
              ) : (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '50vh',
                  }}
                >
                  <CircularProgress />
                </div>
              )}
            </DialogContent>
          </Dialog>
          <Dialog
            aria-labelledby="customized-dialog-title"
            fullWidth={true}
            maxWidth={'lg'}
            onClose={() => {
              setSnapShopView(false);
            }}
            open={snapShopView}
            style={{ zIndex: 1050 }}
          >
            <DialogTitle
              id="customized-dialog-title"
              onClose={() => setSnapShopView(false)}
            >
              <Box
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}
              >
                <Box>
                  <Typography gutterBottom={true} variant="h5">
                    Configuración de Snapshots{' '}
                    {selectedCorp ? `- ${selectedCorp.name}` : ''}
                  </Typography>
                </Box>
                <IconButton
                  aria-label="close"
                  onClick={() => setSnapShopView(false)}
                  size="small"
                >
                  <Close />
                </IconButton>
              </Box>
            </DialogTitle>
            <DialogContent>
              <FromStrepper
                formData={formData}
                selectedCharge={selectedCorp}
                setFormData={setFormData}
              />
              {/* {renderDias()} */}
            </DialogContent>
            <DialogActions>
              {snapShot && snapShot.length > 0 ? (
                <ButtonMaterial
                  color="secondary"
                  disabled={
                    !formData.resource_id ||
                    !formData.frecuency_config.periods.length ||
                    !formData.frecuency_config.days.length ||
                    !formData.contacts.length
                  }
                  onClick={handleSnapShot}
                  variant="contained"
                >
                  Editar
                </ButtonMaterial>
              ) : (
                <ButtonMaterial
                  color="secondary"
                  disabled={
                    !formData.resource_id ||
                    !formData.frecuency_config.periods.length ||
                    !formData.frecuency_config.days.length ||
                    !formData.contacts.length
                  }
                  onClick={handleSnapShot}
                  variant="contained"
                >
                  Guardar
                </ButtonMaterial>
              )}
              <ButtonMaterial
                color="secondary"
                onClick={() => setSnapShopView(false)}
                variant="outlined"
              >
                Cerrar
              </ButtonMaterial>
            </DialogActions>
          </Dialog>
          <UploadDocuments
            corporative={coporative_id}
            open={openDocuments}
            selectedCorp={selectedCorp}
            setOpen={setOpenDocuments}
          />
        </>
      )}
      <SpeedDial
        ariaLabel="SpeedDial basic example"
        sx={{
          position: 'fixed',
          bottom: 32,
          right: 32,
          '& .MuiFab-primary': {
            width: 80, // Ajusta el tamaño del botón principal
            height: 80,
            backgroundColor: '#A53693', // Cambia el color de fondo
            '&:hover': {
              backgroundColor: '#6A1A5F',
            },
          },
        }}
        onClose={handleClose}
        onOpen={handleOpen}
        open={open}
        icon={
          <Settings
            sx={{
              width: 40,
              height: 40,
              transform: 'rotate(0deg)',
              transition: 'transform 0.3s ease-in-out',
              '&:hover': {
                transform: 'rotate(180deg)',
              },
            }}
          />
        }
      >
        <SpeedDialAction
          key={1}
          sx={{
            width: 60, // Ajusta el tamaño del botón secundario
            height: 60,
            backgroundColor: 'rgb(0, 175, 239)', // Cambia el color de fondo
            color: 'white', // Cambia el color del texto
            '&:hover': {
              backgroundColor: 'rgb(0, 146, 199)',
            },
          }}
          icon={<AddIcon />}
          onClick={handleNavigation}
          tooltipTitle="Nuevo Nodo"
        />
      </SpeedDial>
    </>
  );
}
